import { JsonProperty } from "../../../models/utilities/json-property";
import { NotificationSendStatus } from "../enums/notification-send-status";
import { ShipmentSummary } from "../shipments/shipment-summary";

export class ShipmentWithNotifications extends ShipmentSummary {
    @JsonProperty({ toType: 'datetime-specific' })
    public psSent: Date | undefined = undefined;

    @JsonProperty({ toType: 'datetime-specific' })
    public pdSent: Date | undefined = undefined;

    @JsonProperty({ toType: 'datetime-specific' })
    public fdSent: Date | undefined = undefined;

    public timeZoneId: string = "America/Chicago";

    public driverId: number | undefined = undefined;

    //ui elements
    public isLoading: boolean = false;

    public sendSuccess: NotificationSendStatus = NotificationSendStatus.Pending;

    public createSuccess: NotificationSendStatus = NotificationSendStatus.Pending;
}